import { Percomatic } from '@biggby-coffee/percomatic-typescript';

import { HorizontalSelect } from '../../../components/HorizontalSelect';

export type ModifierScaleSelectorProps = {
	modifiers: Percomatic.Serialized.Modifier[];
	selectedIndex: number;
	clickHandler: (index: number) => void;
};

export const ModifierScaleSelector: React.FC<ModifierScaleSelectorProps> = ({
	modifiers,
	selectedIndex,
	clickHandler
}) => (
	<div className="product-modifier-scale-selector">
		<HorizontalSelect
			clickHandler={clickHandler}
			selectedIndex={selectedIndex}
			items={modifiers.map(({ name }) => name)}
		/>
	</div>
);
